module.exports = __WEBPACK_EXTERNAL_MODULE_0iPh__;


//////////////////
// WEBPACK FOOTER
// external "jQuery"
// module id = 0iPh
// module chunks = 0